<section class="login-wrapper">
    <div class="login-header align-center">
        <span class="login-logo"></span>
    </div>
    <h1 class="section-title align-center">User Sign-on for RICK</h1>
    <div class="card login-page">
        <div *ngIf="submitted && f.username.errors?.invalid" class="alert alert-danger alert-dismissible fade show server-error">
            <strong>Error!</strong> Invalid Username or Password.
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        
        <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="mb-3">
                    <input type="text" placeholder="Username" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Username is required</div>
                    </div>
                </div>
                <div class="mb-3 pt-30">
                    <input type="password" placeholder="Password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <div class="align-center mt-25">
                    <button [disabled]="loading" class="btn btn-primary">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                        Login
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="footerText">
        This system is to be used only by authorized persons and by continuing to use this system, 
        you represent that you are an authorized user. Unauthorized access is prohibited. 
        Access to this system is subject to monitoring. VIOLATORS WILL BE PROSECUTED.
    </div>
    </section>